import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';
import { ICON_TYPE_PROP_TYPE } from '@eb/eds-icon';

export const ITEMS_PROP_TYPE = PropTypes.arrayOf(
    PropTypes.shape({
        title: translationPropType,
        iconType: ICON_TYPE_PROP_TYPE,
    }),
);

export const ICON_TYPES = ICON_TYPE_PROP_TYPE;

export const STYLE_NEUTRAL = 'neutral';
export const STYLE_FILL = 'fill';

export const STYLES = [STYLE_NEUTRAL, STYLE_FILL];

export const SIZE_LARGE = 'large';
export const SIZE_SMALL = 'small';

export const SIZES = [SIZE_SMALL, SIZE_LARGE];
